import { render, staticRenderFns } from "./Gelenler.vue?vue&type=template&id=2cd779a5&"
import script from "./Gelenler.vue?vue&type=script&lang=js&"
export * from "./Gelenler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports